<template>
  <div class="loading">
    <md-progress-spinner
      :md-stroke="2"
      :md-diameter="30"
      md-mode="indeterminate"
    ></md-progress-spinner>
    <span style="margin-left: 20px">Loading...</span>
  </div>
</template>
<script>
export default {
  props: ["text"],
};
</script>
<style scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 100;
  top: 2vh;
  padding: 15px;
  color: black;
  margin: auto;
  left: 43vw;
  right: 43vw;
}
</style>
